import { createFileRoute } from '@tanstack/react-router';
import { Conversations } from '@/components/Conversations';

export const Route = createFileRoute('/_auth/conversations/archive')({
  component: ArchivedConversationsRoute,
});

function ArchivedConversationsRoute() {
  return <Conversations archived />;
}
